import { Component, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { FirestoreService } from '../../../services/firestore.service';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-save',
  imports: [
    MatButtonModule,
    MatIcon,
    MatBadgeModule
  ],
  templateUrl: './save.component.html',
  styleUrl: './save.component.scss'
})
export class SaveComponent {

  public unsavedChanges: Signal<boolean> = this.websiteStateService.hasUnsavedChanges;
  public numberOfUnsavedChanges: Signal<number> = this.websiteStateService.numberOfUnsavedChanges;


  constructor(
    private websiteStateService: WebsiteStateService,
    private fireStoreService: FirestoreService) { }

  public save(): void {
    console.log('Save');
    this.fireStoreService.updateWebsiteData(this.websiteStateService.websiteData());
    this.websiteStateService.setUnsavedChanges(false);
  }

}
